angular.module('wbControllers').controller('SavingsPlanController',
  ['$scope', 'finance',
    ($scope, finance) => {
      let calculateGraphData;
      $scope.$watch('options',
        options => calculateGraphData(),
        true);

      function defaultToZero(amount, elementId) {
        if (amount == null) {
          angular.element(elementId).val('0');
        }
      }

      // Prevents errors with copy & graph rendering as empty inputs default to null || undefined
      $scope.$watch('options.currentSavings', () => { defaultToZero($scope.options.currentSavings, '#current-savings'); });
      $scope.$watch('options.contributionAmount', () => { defaultToZero($scope.options.contributionAmount, '#contribution-amount'); });
      $scope.$watch('options.yearsOfContribution', () => { defaultToZero($scope.options.yearsOfContribution, '#years-of-contribution'); });
      $scope.$watch('options.rateOfReturn', () => { defaultToZero($scope.options.rateOfReturn, '#rate-of-return'); });

      $scope.frequencyOptions = [
        {
          name: 'Weekly',
          frequency: 52,
        },
        {
          name: 'Twice a month',
          frequency: 24,
        },
        {
          name: 'Monthly',
          frequency: 12,
        },
        {
          name: 'Every three months',
          frequency: 4,
        },
        {
          name: 'Twice a year',
          frequency: 2,
        },
        {
          name: 'Yearly',
          frequency: 1,
        },
      ];

      $scope.options = {
        contributionFrequency: $scope.frequencyOptions[2],
        contributionAmount: 500,
        currentSavings: 10000,
        yearsOfContribution: 30,
        rateOfReturn: 0.06,
      };

      $scope.futureValue = () => {
        return finance.futureValueByContributionFrequency($scope.options.contributionAmount, $scope.options.contributionFrequency.frequency, $scope.options.rateOfReturn, $scope.options.yearsOfContribution, $scope.options.currentSavings);
      };

      $scope.totalInterest = () => $scope.futureValue() - $scope.totalContribution() - $scope.options.currentSavings;

      $scope.totalContribution = () => {
        return ($scope.options.contributionAmount * $scope.options.contributionFrequency.frequency) * $scope.options.yearsOfContribution;
      };

      return calculateGraphData = () => {
        $scope.savingsPlan = [];
        let year = 1;
        let savings = 0;
        let contribution = 0;

        $scope.currentSavingsStatus = () => {
          if ($scope.options.currentSavings !== 0) { return true; }
        };

        $scope.currentContributionStatus = () => {
          if ($scope.options.contributionAmount !== 0) { return true; }
        };

        while (year <= $scope.options.yearsOfContribution) {
          savings = finance.futureValueByContributionFrequency($scope.options.contributionAmount, $scope.options.contributionFrequency.frequency, $scope.options.rateOfReturn, year, $scope.options.currentSavings);
          contribution = ($scope.options.contributionAmount * $scope.options.contributionFrequency.frequency) * year;

          $scope.savingsPlan.push({
            year,
            savings,
            contribution: contribution + $scope.options.currentSavings,
          });
         year++;
        }
      };
    },
  ],
);
